var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-chart',{attrs:{"height":"200px","data":_vm.data,"colors":_vm.colors}})}
var staticRenderFns = []

export { render, staticRenderFns }